import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { LawyersApiService } from 'src/app/core/services/api/lawyers-api.service';
import { ServicesApiService } from 'src/app/core/services/api/services-api.service';
import { TimesheetApiService } from 'src/app/core/services/api/timesheet-api.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { NgSelectProps } from 'src/app/shared/models/ng-select-props';
import { Service } from 'src/app/shared/models/services/service';
import { Timesheet } from 'src/app/shared/models/timesheet/timesheet';
import { EntryState, TimesheetEntry } from 'src/app/shared/models/timesheet/timesheetEntry';
import { TimesheetEntrySearchParams } from 'src/app/shared/models/timesheet/timesheetSearchParams';
import { User } from 'src/app/shared/models/users/user';
import { TimesheetEntryModalComponent } from 'src/app/shared/timesheet/timesheet-entry-modal/timesheet-entry-modal.component';

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.scss']
})
export class TimesheetComponent implements OnInit {

  public entry: TimesheetEntry[] = [];
  public timesheets: Timesheet[] = [];
  public services: Service[] = [];

  public pending = 0;
  public invoiced = 0;
  public paid = 0;
  public count = 0;
  public params: TimesheetEntrySearchParams = new TimesheetEntrySearchParams();
  columnMode: ColumnMode;
  selected = [];
  selectionType = SelectionType;

  @ViewChild('myTable') table: any;
  @ViewChild('filterModal') filterModal;
  modalRef: NgbModalRef;
  public lawyersNgSelect = null;
  public tsNgSelect = null;
  public servicesNgSelect = null;

  @ViewChild('timesheetEntryModal') timesheetEntryModal: TimesheetEntryModalComponent;

  user: User;

  constructor(
    private spinner: NgxSpinnerService,
    private apiService: TimesheetApiService,
    private modalService: NgbModal,
    private lawyerApi: LawyersApiService,
    private servicesApi: ServicesApiService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private fileApi: FilesApiService
  ) { }

  ngOnInit(): void {
    this.loadItems();
    this.lawyersNgSelect = new NgSelectProps(this.lawyerApi.getLawyersLite);
    this.tsNgSelect = new NgSelectProps(this.fileApi.getFilesTiny);
    this.servicesNgSelect = new NgSelectProps(this.servicesApi.getAllServices);
    this.user = this.authService.user;
  }

  loadItems() {
    this.spinner.show();
    this.apiService.getTimesheetEntries(this.params).subscribe(d => {
      this.entry = d.results;
      this.count = d.count;
      this.pending = d.pending;
      this.paid = d.paid;
      this.invoiced = d.invoiced;
      this.spinner.hide();
    });
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadItems();
  }

  openFilterModal() {
    this.modalRef = this.modalService.open(this.filterModal, { centered: true, size: 'lg' });
  }
  onFilterApply() {
    this.modalRef.close();
    this.params.page = 1;
    this.loadItems();
  }

  resetFilter() {
    this.params = new TimesheetEntrySearchParams();
    this.loadItems();
    this.modalRef.close();
  }

  onSearch(e: KeyboardEvent) {
    if (e.keyCode === 13) {
      this.params.page = 1;
      this.params.search = (e.target as HTMLInputElement).value;
      this.loadItems();
    }
  }

  onSelect({ selected }) {
    this.router.navigate([`/files/${selected[0].caseId}/timesheet`], { relativeTo: this.route });
  }

  openFile(ts: TimesheetEntry) {
    this.router.navigate([`/files/${ts.caseId}`], { relativeTo: this.route });
  }

  searchFn() {
    return true;
  }

  isEditable(entry: TimesheetEntry) {
    return entry.state != EntryState.PAID;
  }

  editTimesheetModal(entry: TimesheetEntry) {
    this.timesheetEntryModal.openEntryForm(Object.assign(new TimesheetEntry(), entry), [entry.lawyer]);
  }
}
